<div class="page-content">
    <p-panel header="Service Requests" class="no-x-padding">
        <app-service-request-crud [showProject]="true"></app-service-request-crud>
    </p-panel>
</div>
